module.exports = __webpack_public_path__ + "img/logo-cc-migross.356baf76.svg";